import { ApiAudience, ApiAudiencePayload } from "@incendium/api";
import { audienceService } from "Apis";
import { isEmpty } from "Helpers/isEmpty";

const audienceToPayload = (audience: ApiAudience): ApiAudiencePayload => {
  return {
    name: audience.name,
    description: audience.description,
    conditionGroups: audience.conditionGroups?.filter((c) => {
      return (
        !isEmpty(c) &&
        (c.conditions || []).filter((co) => !isEmpty(co)).length > 0
      );
    })
  };
};

export const saveAudience = async (projectId: number, audience: ApiAudience) => {
  const fn = audience.id ? audienceService.audienceServiceUpdateAudience({
    projectId,
    audienceId: audience.id as number,
    payload: audienceToPayload(audience),
  }) : audienceService.audienceServiceCreateAudience({
    projectId,
    payload: audienceToPayload(audience),
  });
  const res = await fn;
  return res;
};